import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { bindActionCreators } from 'redux';
import './App.scss';
import Hero from './components/Hero/Hero';
import { ContentProvider } from './context/ContentProvider';
import data from './data/content.json';
import { AppDispatch, RootState } from './store';
import { fetchAppSetup } from './store/features/app/app';
import { IContent } from './types';
import { getProductIds, sendWaData } from './utils';

const mapStateToProps = (state: RootState) => ({
  products: state.products,
  app: state.app
});

const mapDisPatchToProps = (dispatch: AppDispatch) => ({
  fetchAppSetup: bindActionCreators(fetchAppSetup, dispatch)
});

const connector = connect(mapStateToProps, mapDisPatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type AppProps = PropsFromRedux & {
  localeId: string;
};

const App = ({ localeId }: AppProps) => {
  const localizedContent: IContent = data.filter(
    locale => locale.lang === localeId
  )[0];

  useEffect(() => {
    sendWaData({
      siteSection: 'homepage',
      pageName: 'homepage - uplaystore - custom'
    });
  }, []);

  return (
    <main id="lunar-flash-sale">
      <ContentProvider value={localizedContent}>
        <Hero />
      </ContentProvider>
    </main>
  );
};

export default connector(App);
